<div class="py-[30px]" [formGroup]="form">
  <!-- checkin-guide -->
  <div>
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "property-property_detail-advanced_html_入住指南" | translate }}
            <!-- Check-in Guide -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "property-property_detail-advanced_html_入住指南说明" | translate }}
            <!-- Complete basic property information to use the check-in guide. -->
          </div>
        </div>
      </div>
      <div>
        <a routerLink="/app/settings/check-in-guide">
          <button nz-button nzSize="large">
            {{ "property-property_detail-advanced_html_设置" | translate }}
            <!-- Set -->
          </button>
        </a>
      </div>
    </div>
  </div>

  <!-- reservations   -->
  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "property-property_detail-advanced_html_订单" | translate }}
            <!-- Reservations -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "property-property_detail-advanced_html_订单说明" | translate }}
            <!-- View all reservations for this property. -->
          </div>
        </div>
      </div>
      <div>
        <a routerLink="/app/reservations" [queryParams]="{ house_ids: houseId }">
          <button nz-button nzSize="large">
            {{ "word.view" | translate }}
            <!-- View -->
          </button>
        </a>
      </div>
    </div>
  </div>

  <!-- 整租分租房态联动 -->
  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">{{ "house.whole_and_sub_house_status_linkage" | translate }}</div>
          <div class="v4-layout-form-desc">{{ "house.whole_and_sub_house_status_linkage_info" | translate }}</div>
        </div>
      </div>
      <div>
        @if (!isSubHouse) {
          <nz-switch formControlName="is_link_sub_house"></nz-switch>
        }
      </div>
    </div>

    @if (isSubHouse) {
      <div
        class="extra-text"
        (click)="toMasterHouse()"
        [innerHTML]="
          'house.sub_house_should_be_set_in_parent_house' | translate: { title: masterHouse?.title_alias } | html
        "></div>
    } @else {
      @if (subHouseList?.length) {
        <div class="v4-option-list mt-3">
          <div class="v4-option-item" *ngFor="let house of subHouseList">
            <div class="v4-option">
              <span>{{ house.title_alias }}</span>
              <span class="ml-2 cursor-pointer" (click)="onDeleteHouseItem(house.id)">x</span>
            </div>
          </div>
        </div>
        <a nz-button nzType="link" (click)="onClickAddHouse()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          <!-- 子房间 -->
          {{ "house.sub_house" | translate }}
        </a>
      }
    }
  </div>

  <!-- preparation time -->
  <!-- <div class="mt-12">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "property-property_detail-advanced_html_preparation_time" | translate }}
            <img src="/assets/icon/icon_forbidden.png" class="w-[18px] h-[18px]" />
          </div>
          <div class="v4-layout-form-desc">
            {{ "property-property_detail-advanced_html_preparation_time_desc" | translate }}
          </div>
        </div>
      </div>
      <div>
        <nz-switch formControlName="stop_status"></nz-switch>
      </div>
    </div>
  </div> -->

  <!-- timezone -->
  <div class="mt-[36px]" *ngIf="isInternational">
    <div class="flex flex-row items-center">
      <div class="v4-layout-form">
        <div class="v4-layout-form-title">
          {{ "property-property_detail-advanced_html_时区" | translate }}
          <!-- Timezone -->
        </div>
        <div class="v4-layout-form-desc">
          {{ "property-property_detail-advanced_html_时区说明" | translate }}
          <!-- If this property or the listings linked with this property has geolocation data, then the system will
          automatically calculate the time zone based on the location, otherwise the global time zone setting will be
          used. Check this option to change the time zone manually. -->
        </div>
      </div>
    </div>
    <div>
      <nz-select
        class="w-full"
        [nzPlaceHolder]="'property-property_detail-advanced_html_时区' | translate"
        nzSize="large"
        [nzOptions]="optionsOfTimezone"
        formControlName="timezone"></nz-select>
    </div>
  </div>

  <!-- 超售 -->
  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">{{ "house.allow_overbooking" | translate }}</div>
          <div class="v4-layout-form-desc">{{ "house.set_allow_house_overbook_info" | translate }}</div>
        </div>
      </div>
      <div>
        <nz-switch formControlName="is_allowed_overbooking"></nz-switch>
      </div>
    </div>

    <ng-container *ngIf="oversaleDateItems.length">
      <div class="v4-option-list mt-3">
        <div class="v4-option-item" *ngFor="let item of oversaleDateItems; let index = index">
          <div class="v4-option">
            <img
              *ngIf="item.thirdparty_type !== undefined"
              [src]="(item.thirdparty_type | thirdparty)?.icon_color"
              class="w-[18px] h-[18px] rounded-full mr-1" />
            <span>{{ item.from | dateformat: ["YMD"] }}</span>
            <span *ngIf="item.from !== item.to">&nbsp;~&nbsp;{{ item.to | dateformat: ["YMD"] }}</span>
            <span class="ml-2 cursor-pointer" (click)="onDeleteDateItem(item, index)">x</span>
          </div>
        </div>
      </div>
      <a nz-button nzType="link" (click)="onClickAddDateItem()">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        <!-- 超售日期 -->
        {{ "house.overbooking_date" | translate }}
      </a>
    </ng-container>
  </div>

  <!-- Stop Automatic Availability Syncing -->
  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "property-property_detail-advanced_html_停止自动开关房" | translate }}
            <!-- Stop Automatic Availability Syncing -->
            <img src="/assets/icon/icon_stop_on_off.png" class="w-[18px] h-[18px]" />
          </div>
          <div class="v4-layout-form-desc">
            {{ "property-property_detail-advanced_html_停止自动开关房说明" | translate }}
            <!-- Enabling this option will stop the automatic availability syncing for this property. -->
          </div>
        </div>
      </div>
      <div>
        <nz-switch formControlName="is_stop_managing_inventory"></nz-switch>
      </div>
    </div>
  </div>

  <!-- 停用 -->
  <div class="mt-[36px]">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "property-property_detail-advanced_html_停用" | translate }}
            <!-- Deavtivate -->
            <img src="/assets/icon/icon_forbidden.png" class="w-[18px] h-[18px]" />
          </div>
          <div class="v4-layout-form-desc">
            {{ "property-property_detail-advanced_html_停用说明" | translate }}
            <!-- If the date set to deactivated, the availability will be closed and will not be counted as sellable room
            nights. -->
          </div>
        </div>
      </div>
      <div>
        <nz-switch formControlName="stop_status"></nz-switch>
      </div>
    </div>

    <ng-container *ngIf="stopDateItems?.length">
      <div class="v4-option-list mt-3">
        <div class="v4-option-item" *ngFor="let item of stopDateItems; let index = index">
          <div class="v4-option">
            <span>{{ item.from | dateformat: ["YMD"] }}</span>
            <span *ngIf="item.from !== item.to">&nbsp;~&nbsp;{{ item.to | dateformat: ["YMD"] }}</span>
            <!-- <p>{{ item }}</p> -->
            <span class="ml-2 cursor-pointer" (click)="onDeleteStopDateItem(item, index)">x</span>
          </div>
        </div>
      </div>

      <a nz-button nzType="link" (click)="onClickAddStopDates()">
        <i nz-icon nzType="plus" nzTheme="outline"></i>
        {{ "property.property_detail.status_setting.btn.add_stop_dates" | translate }}
      </a>
    </ng-container>
  </div>
</div>
